export const WaveLine = ({ className = "", color = "#0D9488", slow = false, opacity = 1, stroke = 1.5 }) => {
  const d = "M0 50 Q 25 0 50 50 T 100 50 T 150 50 T 200 50 T 250 50 T 300 50 T 350 50 T 400 50";
  return (
    <div className={`overflow-hidden ${className}`} aria-hidden="true">
      <svg className={`wave-track ${slow ? "slow" : ""}`} width="200%" height="100%" viewBox="0 0 400 100" preserveAspectRatio="none" style={{ opacity }}>
        <path d={d} fill="none" stroke={color} strokeWidth={stroke} vectorEffect="non-scaling-stroke" />
        <path d="M0 50 H20 V20 H45 V80 H70 V20 H95 V80 H120 V20 H145 V80 H170 V20 H195 V80 H220 V20 H245 V80 H270 V20 H295 V80 H320 V20 H345 V80 H370 V20 H400" fill="none" stroke={color} strokeWidth={Math.max(1, stroke * 0.66)} strokeOpacity="0.35" vectorEffect="non-scaling-stroke" />
      </svg>
    </div>
  );
};

export const KeySeq = ({ keypad, code, small = false }) => {
  const parts = keypad ? keypad.split(",").map((s) => s.trim()).filter(Boolean) : ["AUTO", code, "RUN"];
  return (
    <div className="flex flex-wrap sm:flex-nowrap items-center gap-1.5" data-testid="key-sequence">
      {parts.map((p, i) => (
        <span key={i} className="flex items-center gap-1.5">
          <span className={`font-mono rounded-md border ${small ? "px-2 py-0.5 text-xs" : "px-2.5 py-1 text-sm"} ${
            p === "AUTO" || p === "RUN" || p === "SELECT" ? "bg-[#0B1013] text-white border-[#0B1013]" : "bg-white text-[#0F766E] border-[#0D9488]/40 font-bold"}`}>{p}</span>
          {i < parts.length - 1 && <span className="text-slate-400 text-xs">›</span>}
        </span>
      ))}
    </div>
  );
};
